import { render } from "./EditorRender.vue?vue&type=template&id=4af73136"
import script from "./EditorRender.vue?vue&type=script&lang=js"
export * from "./EditorRender.vue?vue&type=script&lang=js"

import "./EditorRender.vue?vue&type=style&index=0&id=4af73136&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__